var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 20,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs8"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    className: "cls-1",
    d: "M14 17a2 2 0 1 0-2-2 2 2 0 0 0 2 2zm0 2a4 4 0 1 1 4-4 4 4 0 0 1-4 4zM11.62 7l-1.73 3.45A1 1 0 0 1 9 11H6v10h16V11h-3a1 1 0 0 1-.9-.55L16.39 7ZM22 9a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h2.38l1.73-3.45A1 1 0 0 1 11 5h6a1 1 0 0 1 .9.55L19.61 9Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-2",
    "data-name": "SVGID",
    className: "cls-1",
    style: {
      fill: "none"
    },
    d: "M0 0h28v28H0z"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:none}"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)",
    id: "g16",
    style: {
      fill: "#9cad4c",
      fillOpacity: 1,
      clipPath: "url(#clip-path)"
    },
    transform: "translate(-4 -5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-2)",
    id: "g14",
    style: {
      fill: "#9cad4c",
      fillOpacity: 1,
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect12",
    style: {
      fill: "#9cad4c",
      fillOpacity: 1
    },
    d: "M-1 0h30v28H-1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.4f06839059f8d1262ba0c6ef361a2c96.svg";
export { ForwardRef as ReactComponent };